import { ReactNode } from 'react';
import Group from '../Group';
import { Tooltip } from 'antd';
import { HelpCircle } from 'react-feather';

interface Props {
  title?: string;
  children?: ReactNode;
}

export default function HelpIcon(props: Props) {
  return (
    <Group>
      {props.children}

      <Tooltip title={props.title}>
        <HelpCircle size={16} />
      </Tooltip>
    </Group>
  );
}
